import React, { useCallback, useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Table, Chip, Person, fmt } from "./kit";

const small = { fontSize: 12, color: "#6B7280" };
// input type="datetime-local" yerel saat ister
const toLocal = (iso) => {
  const d = new Date(iso);
  if (isNaN(d)) return "";
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};

const PkTournament = () => {
  const [cfg, setCfg] = useState(null);
  const [top, setTop] = useState([]);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");

  const load = useCallback(async () => {
    const r = await api.pkTournament();
    if (r?.status) {
      setCfg({ ...r.config, startsAt: toLocal(r.config.startsAt), endsAt: toLocal(r.config.endsAt) });
      setTop(r.top || []);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const save = async (next = cfg) => {
    setSaving(true);
    const body = { ...next, startsAt: new Date(next.startsAt).toISOString(), endsAt: new Date(next.endsAt).toISOString() };
    const r = await api.pkTournamentSave(body);
    setSaving(false);
    if (!r?.status) return window.alert(r?.message || "Kaydedilemedi");
    setMsg("Kaydedildi");
    setTimeout(() => setMsg(""), 3000);
    load();
  };

  if (!cfg) return <PageHead title="PK Turnuvası" sub="Yükleniyor…" />;

  const set = (k, v) => setCfg({ ...cfg, [k]: v });
  const setReward = (i, k, v) => set("rewards", cfg.rewards.map((r, j) => (j === i ? { ...r, [k]: v } : r)));

  return (
    <>
      <PageHead
        title="PK Turnuvası"
        sub="Tarih aralığında biten PK'lardan canlı puan tablosu. Ödülleri turnuva bitince buradaki sıralamaya göre sen verirsin."
        right={
          <div className="d-flex align-items-center" style={{ gap: 10 }}>
            {msg && <span style={{ fontSize: 13, color: "#059669" }}>{msg}</span>}
            {cfg.enabled ? <Chip>Uygulamada açık</Chip> : <Chip kind="wait">Kapalı</Chip>}
            <button className={`btn ${cfg.enabled ? "btn-outline-danger" : "btn-success"}`} onClick={() => save({ ...cfg, enabled: !cfg.enabled })} disabled={saving}>
              {cfg.enabled ? "Kapat" : "Aç"}
            </button>
          </div>
        }
      />

      <div className="row">
        <div className="col-lg-5 mb-3">
          <div className="card">
            <div className="card-body">
              <div style={small}>Başlık</div>
              <input className="form-control mb-2" value={cfg.title} onChange={(e) => set("title", e.target.value)} />
              <div style={small}>Alt yazı</div>
              <input className="form-control mb-2" value={cfg.subtitle} onChange={(e) => set("subtitle", e.target.value)} />
              <div className="row">
                <div className="col-6 mb-2">
                  <div style={small}>Başlangıç</div>
                  <input className="form-control" type="datetime-local" value={cfg.startsAt} onChange={(e) => set("startsAt", e.target.value)} />
                </div>
                <div className="col-6 mb-2">
                  <div style={small}>Bitiş</div>
                  <input className="form-control" type="datetime-local" value={cfg.endsAt} onChange={(e) => set("endsAt", e.target.value)} />
                </div>
                <div className="col-4 mb-2">
                  <div style={small}>Galibiyet puanı</div>
                  <input className="form-control" type="number" value={cfg.winPoints} onChange={(e) => set("winPoints", e.target.value)} />
                </div>
                <div className="col-4 mb-2">
                  <div style={small}>Beraberlik puanı</div>
                  <input className="form-control" type="number" value={cfg.drawPoints} onChange={(e) => set("drawPoints", e.target.value)} />
                </div>
                <div className="col-4 mb-2">
                  <div style={small}>Mağlubiyet puanı</div>
                  <input className="form-control" type="number" value={cfg.lossPoints} onChange={(e) => set("lossPoints", e.target.value)} />
                </div>
                <div className="col-6 mb-2">
                  <div style={small}>En az toplam hediye puanı (altı sayılmaz)</div>
                  <input className="form-control" type="number" value={cfg.minScore} onChange={(e) => set("minScore", e.target.value)} />
                </div>
                <div className="col-6 mb-2">
                  <div style={small}>Aynı ikili günde en fazla PK</div>
                  <input className="form-control" type="number" value={cfg.maxPerPairDaily} onChange={(e) => set("maxPerPairDaily", e.target.value)} />
                </div>
              </div>

              <div className="mt-2 mb-1">
                <b>Ödüller</b>
                <div style={small}>Sadece uygulama içi eşya yaz (çerçeve, rozet, öne çıkma). Nakit ödül yazma.</div>
              </div>
              {cfg.rewards.map((r, i) => (
                <div key={i} className="d-flex mb-2" style={{ gap: 6 }}>
                  <input className="form-control" style={{ width: 80 }} value={r.place} onChange={(e) => setReward(i, "place", e.target.value)} placeholder="1." />
                  <input className="form-control" value={r.text} onChange={(e) => setReward(i, "text", e.target.value)} />
                  <button className="btn btn-sm btn-outline-danger" onClick={() => set("rewards", cfg.rewards.filter((_, j) => j !== i))}>
                    Sil
                  </button>
                </div>
              ))}
              <div className="d-flex" style={{ gap: 8 }}>
                <button className="btn btn-sm btn-outline-secondary" onClick={() => set("rewards", [...cfg.rewards, { place: "", text: "" }])}>
                  Ödül ekle
                </button>
                <button className="btn btn-primary ml-auto" onClick={() => save()} disabled={saving}>
                  {saving ? "Kaydediliyor…" : "Kaydet"}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-7">
          <Table
            empty="Henüz puan alan yayıncı yok."
            head={["Sıra", "Yayıncı", "ID", "Puan", "G / B / M", "PK", "Hediye puanı"]}
            rows={top.map((r) => (
              <tr key={r.hostId}>
                <td>
                  <b>{r.rank}</b>
                </td>
                <td>
                  <Person image={r.image} name={r.name} />
                </td>
                <td>
                  <code>{r.uniqueID}</code>
                </td>
                <td>
                  <b>{r.points}</b>
                </td>
                <td>
                  {r.wins} / {r.draws} / {r.losses}
                </td>
                <td>{r.played}</td>
                <td>{fmt(r.score)}</td>
              </tr>
            ))}
          />
        </div>
      </div>
    </>
  );
};

export default PkTournament;
